export default "__VITE_PUBLIC_ASSET__180bd945__"